import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { MACHINE_MANUFACTURERS } from 'utils/constants';
import { getMachineControlTiers } from 'api/admin/devices/devices';
import { ApiError } from 'types/api';

interface UseMachineControlTiersPayload {
  style?: string | null;
  manufacturer?: MACHINE_MANUFACTURERS | null;
  enabled?: boolean;
}

interface ControlTier {
  displayValue: string;
  rawValue: string;
}

interface UseMachineControlTiersOutput {
  success: boolean;
  controlTiers: ControlTier[];
}

export const useMachineControlTiers = ({
  style,
  manufacturer,
  enabled = true,
}: UseMachineControlTiersPayload) => {
  return useQuery<unknown, ApiError, UseMachineControlTiersOutput>({
    queryKey: ['getMachineControlTiers', { style, manufacturer }],
    queryFn: async () => {
      if (!style || !manufacturer) {
        return [];
      }

      const { data } = await getMachineControlTiers({
        style,
        manufacturer,
      });

      return data;
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ?? 'An error occurred while loading machine control tiers',
        {
          duration: 4000,
        },
      );
      return error;
    },
    enabled,
  });
};
